import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Badge from '@mui/material/Badge';
import FormControl from '@mui/material/FormControl';
//import FormLabel from '@mui/material/FormLabel';
//import FormGroup from '@mui/material/FormGroup';
//import Select,{SelectChangeEvent} from '@mui/material/Select';
//import MenuItem from '@mui/material/MenuItem';
//import FormHelperText from '@mui/material/FormHelperText';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import Checkbox from '@mui/material/Checkbox';
//import List from '@mui/material/List';
//import ListItemButton from '@mui/material/ListItemButton';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
//import ListItemAvatar from '@mui/material/ListItemAvatar';
import {Owner,Secret,Item} from './Inc';
//import ColInput from './ColInput';
import Toast from './Toast';
import RowData from './RowData';
import Ajax from './Ajax';
import Loading from './Loading';
import SecretConfirm from './SecretConfirm';
import Title from './Title';
import ItemCheckTable from './ItemCheckTable';
//import StoreImg from './StoreImg';

interface Props {
    owner:Owner,
}

//let errors:string[] = [];

const SecretInput = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const defItems:Item[] = [];
    const defCheckedIds:number[] = [];
    //const defDays:Dataset[] = [];
    const [states,setStates] = useState({
        items: defItems,
        ngItems: defItems,
        checkedIds: defCheckedIds,
        checkedItems: defItems,
        ready: false,
        errorName: "",
        redirectId: 0,
        isLoading: true,
        isConfirm: false,
        allChecked: false,
    });
    const [toast,setToast] = useState("");

    //const addError = (name:keyof Secret,isError:boolean) =>{
    //    if( isError ){
    //        if( !errors.includes(name) ){
    //            errors.push( name );
    //        }
    //    } else {
    //        if( errors.includes(name) ){
	//    		const index = errors.findIndex((v) => v===name);
	//	    	errors.splice(index,1);
    //        }
    //    }
    //}
    const confirm = ()=>{
        //console.log("states",states);
        //console.log("errors",errors);
        if( states.checkedIds.length===0 ){
            setToast("商品が選択されていません");
        } else {
            setStates({...states,isConfirm:true});
        }
    }
	const closeToast = ()=>{
        setToast("");
	}

    const send = (secret:Secret)=>{
        setStates({...states,isLoading:true});
        Ajax.send("secret/do",{secret:secret,item_ids:states.checkedIds},(res:any)=>{
            console.log(res);
            if( res.ok ){       
                setStates({...states,redirectId:1,isLoading:false});
            }
        });
    }
    const closeModal = ()=>{
		setStates({...states,isConfirm:false});
	};
	const check = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( !states.checkedIds.includes(item.item_id) ){
			setStates({...states,"checkedItems":states.checkedItems.concat(item),"checkedIds":states.checkedIds.concat(item.item_id)});
		}
	}
	const uncheck = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( states.checkedIds.includes(item.item_id) ){
			let ids = states.checkedIds;
			const index1 = ids.findIndex((v) => v===item.item_id);
			ids.splice(index1,1);

			let items = states.checkedItems;
			const index2 = items.findIndex((v) => v.item_id===item.item_id);
			items.splice(index2,1);

			setStates({...states,"checkedItems":items,"checkedIds":ids});
		}
	}
	const isChecked = (id:number)=>{
		return states.checkedIds.includes(id);
	}

    useEffect( ()=>{
        if( props.owner.owner_id>0 ){
            Ajax.send("secret/items",{},(res:any)=>{
                //console.log(res);
                if( res.ok ){
                    setStates({...states,"isLoading":false,"items":res.items,"ngItems":res.ng_items});
                }
            });
        } else {
            setStates({...states,"isLoading":false});
        }
    } ,[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	
    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

    if( states.redirectId>0 ){
        return (
            <Redirect to="/secret"/>
        )
    }

	return (
		<div id="profile_input" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="新しいシークレット" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                        商品を１つ以上選択してから、「パスワードを設定する」を押して下さい。 <br/>
                        </div>
						<ItemCheckTable items={states.items} owner={props.owner} check={check} uncheck={uncheck} isChecked={isChecked}/>						
						{states.ngItems.length>0 &&
						<div style={{padding:"1em",fontSize:"80%",marginTop:"3em"}}>
							▼次の商品は画像が未設定のため選択できません。<br/>
							{states.ngItems.map((item:Item,index:number)=>{
								const key = "item"+index;
								//const v = states.checkedIds.includes(item.item_id);
								return (
									<div key={key}>
										<span className={classes.itemId}>ID:{item.item_id}</span>
										<span> {item.item_name}</span>
									</div>
								)
							})}
						</div>
						}
                        <Hidden mdUp implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={12}>
                                    <FormControl fullWidth={true}>
                                        <Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.checkedIds.length===0}>この内容で登録する</Button></Badge>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Link to="/secret"><Button variant="outlined" style={{width:"100%"}}>やめる</Button></Link>
                                </Grid>
                            </Grid>
							<ul className={classes.guideUl}>
								<li className={classes.guideLi}>シークレットを設定できるのは状態表示が「非公開」または「在庫なし」の商品だけです。</li>
								<li className={classes.guideLi}>発売日とシークレットは同時に設定できません。</li>
							</ul>
                        </Hidden>

                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="設定可能商品数" value={String(states.items.length)} width="60%"/>
                        <RowData name="画像未設定" value={String(states.ngItems.length)} width="60%"/>

                        <Hidden smDown implementation="js">
                            <Divider style={{margin:"1em 0"}}/>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={12}>
                                    <FormControl fullWidth={true}>
                                        <Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.checkedIds.length===0}>パスワードを設定する</Button></Badge>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Button variant="outlined" component={Link} to="/secret" style={{width:"100%"}}>やめる</Button>
                                </Grid>
                            </Grid>
							<ul className={classes.guideUl}>
								<li className={classes.guideLi}>シークレットを設定できるのは状態表示が「非公開」または「在庫なし」の商品だけです。</li>
								<li className={classes.guideLi}>発売日とシークレットは同時に設定できません。</li>
							</ul>

                        </Hidden>
                    </Paper>
                </Grid>
            </Grid>
			<SecretConfirm send={send} isOpen={states.isConfirm} close={closeModal} owner={props.owner} items={states.checkedItems}/>
            <Toast close={closeToast} mes={toast}/>
		</div>
	);
}

export default SecretInput;
